/**
 * This mixin requires 'this.dataUrl' to be present.
 */
export default {
  computed: {
    dataParts () {
      // FIXME: Watch out, short files are reported as application/octet stream - we might want to override the mime type then if only ASCII.
      const content = this.dataUrl
      if (!content) {
        return null
      }
      // 0: 'data'
      // 1: 'mime/type'
      // 2: 'base64' || content
      // 3: content if 2 is 'base64'
      const split = content.split(/[:;,]/)
      const mimeType = split[1]
      // If base64 encoded, binary is the binary representation.
      if (split[2] === 'base64') {
        const binary = atob(split[3])
        // Convert utf8 to utf16 to get plaintext.
        const text = mimeType.substring(0, 5) === 'text/' ? this.utf8ToUtf16(binary) : null
        return {mimeType, binary, text}
      }
      // If not base64 encoded, binary is an uri encoded UTF8 string.
      const decoded = decodeURIComponent(split[2])
      // Convert binary from utf16 to raw bytes.
      const binary = this.utf16toUtf8(decoded)
      const text = mimeType.substring(0, 5) === 'text/' ? decoded : null

      return {mimeType, binary, text}
    },
    mimeType () {
      const dataParts = this.dataParts
      if (!dataParts) {
        return null
      }
      return dataParts.mimeType
    },
    binary () {
      const dataParts = this.dataParts
      if (!dataParts) {
        return null
      }

      return dataParts.binary
    },
    text () {
      const dataParts = this.dataParts
      if (!dataParts) {
        return null
      }

      return dataParts.text
    },
    blob () {
      const content = this.dataUrl
      if (!content) {
        return null
      }
      return  this.dataURLtoBlob(content)
    },
    mimeBaseType () {
      const mimeType = this.mimeType
      if (!mimeType) {
        return null
      }
      return mimeType.split('/')[0]
    },
    isText () {
      return this.mimeBaseType && this.mimeBaseType === 'text'
    },
    mimeSubType () {
      const mimeType = this.mimeType
      if (!mimeType) {
        return null
      }
      return mimeType.split('/')[1]
    },
    isImage () {
      return this.mimeBaseType && this.mimeBaseType === 'image'
    }
  },
  methods: {
    utf8ToUtf16 (value) {
      try {
        return decodeURIComponent(value.split('').map(c => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))
      } catch (error) {
        return null
      }
    },
    utf16toUtf8 (value) {
      return encodeURIComponent(value).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode('0x' + p1)
      })
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type:mime});
    }
  }
}
